import Login from '@/pages/Login.vue'
import Contacts from '@/pages/contacts/Contacts.vue'
import Contact from '@/pages/contacts/Contact.vue'
import Users from '@/pages/users/Users.vue'
import User from '@/pages/users/User.vue'
import { withPrefix } from '@/functions/routerHelper'
import { reloadRolesAndPermissions } from '@/extensions/permissions';

let routes = [
    {
        path: '/',
        redirect: {
            name: 'login'
        }
    },
    {
        path: '/login',
        name: 'login',
        component: Login
    },
    {
        path: '/contacts',
        name: 'contacts',
        component: Contacts,
        meta: {
            auth: true,
            menu: true,
            menuName: 'Kontaktai'
        }
    },
    {
        path: '/contact/:id',
        name: 'contact',
        component: Contact,
        meta: {
            auth: true
        }
    },
    {
        path: '/users',
        name: 'users',
        component: Users,
        meta: {
            auth: true,
            menu: true,
            menuName: 'Paskyros',
            role: 'manager|admin',
            hideMenuForRoles: 'manager_limited|manager_admin'
        }
    },
    {
        path: '/user/:id',
        name: 'user',
        component: User,
        meta: {
            auth: true,
            role: 'manager|admin'
        }
    }
]

const getTenantRoutes = async () => {
    await reloadRolesAndPermissions();

    return withPrefix(routes);
};

export { getTenantRoutes, routes }
